/* eslint-disable */
import { CropPortrait } from '@material-ui/icons';
import { React, Fragment, Component } from 'react';
// import Typography from '@material-ui/Typography';
// import Breadcrumbs from '@material-ui/Breadcrumbs';
// import Link from '@material-ui/Link';

// function handleClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {
//   event.preventDefault();
//   console.info('You clicked a breadcrumb.');
// }

import DataTable from 'react-data-table-component';

import Spinner from 'components/Spinner.js';

const columns = [
    {
        name: 'ID',
        selector: row => row.STCKCNTID,
        sortable: true,
    },
    {
      name: 'Description',
      selector: row => row.STCKCNTDSCRPTN,
    },
    {
        name: 'Site',
        selector: row => row.LOCNCODE,
    },
];

// const data = [
//     {
//         id: 1,
//         title: 'Beetlejuice',
//         year: '1988',
//     },
//     {
//         id: 2,
//         title: 'Ghostbusters',
//         year: '1984',
//     },
// ]


export default class GPStockCountJobList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showTable: false,
      showSpinner: true,
      data: []
    };
  }

  componentDidMount() {
    // this.state.socket.on('login', user => this.setState({ user, waitingForAuth: false }));
    // this.state.socket.on('error', err => this.setState({ user: null, waitingForAuth: false }));
    var $this = this;
    fetch('/api/shared/stockCountJobs/listgp', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({LOCNCODE: "WAREHOUSE"})
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if (data.status.success) {
          $this.setState({
            data: data.data.gpStockCountJobs,
            showSpinner: false,
            showTable: true
          });
        }
        else {
          $this.setState({
            showSpinner: false
          });
          alert('There was an error. Please try again later.')
        }
      }).catch(() => {
        $this.setState({
          showSpinner: false
        });
        alert('There was an error. Please try again later.')
      });
  }

  render ()
  {
    return (
      <Fragment>
        {/* <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" href="/">
            MUI
          </Link>
          <Link
            underline="hover"
            color="inherit"
            href="/material-ui/getting-started/installation/"
          >
            Core
          </Link>
          <Typography color="text.primary">Breadcrumbs</Typography>
        </Breadcrumbs> */}
        { this.state.showSpinner ?
          <Spinner/> 
          : "" 
        }
        { this.state.showTable ?
        <DataTable
              columns={columns}
              data={this.state.data}
              keyField='id'
              onRowClicked={r => this.props.pullGP(r.STCKCNTID)}
              striped
              highlightOnHover
              pointerOnHover
              dense
              pagination
          />
          : ""
        }
      </Fragment>
    );
  }
}
